import { createContext } from "react";

export const StarContext = createContext({});